import { memo } from 'react'
import { View } from 'react-native'
import styled from 'styled-components'
import { useButtonHandlers } from '../../../../elements/controls'
import { media } from '../../../../style/media.js'
import { LiveOrCatchUpButton } from '../../WatchButtons/LiveOrCatchUpButton/LiveOrCatchUpButton'
import { RecommendButton } from '../../WatchButtons/RecommendButton/RecommendButton'

const ButtonRow = styled(View)`
  flex-direction: row;
  justify-content: space-between;

  ${media.sm`
    justify-content: space-between;
    margin-top: auto;
    max-width: 270px;
  `};
`

export const PromoButtons = memo(({ content, ...props }) => {
  const { handlers } = useButtonHandlers()

  return (
    <ButtonRow>
      <LiveOrCatchUpButton
        key="liveEventButton"
        isCatchUpShown={true}
        onPress={() => handlers.viewDetails(content)}
        {...props}
      />
      <LiveOrCatchUpButton
        key="catchUpButton"
        isCatchUpShown={false}
        onPress={() => handlers.viewDetails({ ...content, channelSourceSlug: 'catch-up' })}
        {...props}
      />
      <RecommendButton
        onPress={() => handlers.recommendMovie(content, 'contentDetails')}
        {...props}
      />
    </ButtonRow>
  )
})
